import React from "react";
import MuiButton, { ButtonProps as MuiButtonProps } from "@material-ui/core/Button";
import { useStyles } from "./styles";

export type ButtonProps = MuiButtonProps;

/**
 * Drop-in replacement for MUI Button with kit defaults:
 * - textTransform: none  (no uppercase)
 * - fontFamily: Montserrat
 * - disableElevation on contained buttons
 */
const Button = React.forwardRef(
  ({ className, variant, ...props }: MuiButtonProps, ref) => {
    const classes = useStyles();
    return (
      <MuiButton
        // ref type is resolved by MuiButton based on `component`; safe to widen here
        ref={ref as any}
        variant={variant}
        disableElevation={variant === "contained"}
        className={`${classes.root}${className ? ` ${className}` : ""}`}
        {...props}
      />
    );
  }
) as typeof MuiButton & { displayName?: string };

Button.displayName = "Button";
export default Button;
